<template>
  <div class="flex flex-col md:flex-row">
    <vs-button
      v-if="surat.isUserCanDisposition($user.id)"
      @click="$refs.dialogDisposisi.toggleActive(true)"
      class="mr-2 mb-2"
      color="primary"
      icon="icon-arrow-up-right"
      icon-pack="feather"
    >
      Disposisi
    </vs-button>

    <vs-button
      v-if="surat.isUserCanSend($user.id)"
      class="mr-2 mb-2"
      type="border"
      color="primary"
      icon="icon-send"
      icon-pack="feather"
      @click="confirmSendMail"
    >
      Kirim Surat
    </vs-button>

    <vs-button
      v-if="surat.isUserCanArchive($user.id)"
      class="mr-2 mb-2"
      type="border"
      color="primary"
      icon="icon-archive"
      icon-pack="feather"
      @click="confirmArchive"
    >
      Arsipkan
    </vs-button>

    <vs-button
      v-if="surat.isUserCanUnarchive($user.id)"
      type="border"
      class="mr-2 mb-2"
      color="warning"
      icon="icon-archive"
      icon-pack="feather"
      @click="confirmUnarchive"
    >
      Batalkan Arsip
    </vs-button>

    <vs-button
      class="mr-2 mb-2"
      type="border"
      color="warning"
      icon="icon-dollar-sign"
      icon-pack="feather"
      v-if="surat.isUserCanGetNumber()"
      @click="$refs.dialogNomorSurat.toggleActive(true)"
    >
      Ambil Nomor
    </vs-button>

    <vs-button
      class="mr-2 mb-2"
      type="border"
      color="warning"
      icon="icon-calendar"
      icon-pack="feather"
      v-if="surat.isUserCanAgenda()"
      @click="handleAgenda"
    >
      Agendakan
    </vs-button>

    <vs-button
      v-if="surat.isUserCanTrash($user.id) && surat.isUserOnDisposition($user.id)"
      class="mr-2 mb-2"
      type="border"
      color="danger"
      icon="icon-trash"
      icon-pack="feather"
      @click="confirmTrash"
    >
      Jadikan Sampah
    </vs-button>

    <vs-button
      v-if="surat.isUserCanUntrash($user.id) && surat.isUserOnDisposition($user.id)"
      class="mr-2 mb-2"
      type="border"
      color="danger"
      icon="icon-rotate-ccw"
      icon-pack="feather"
      @click="confirmUnTrash"
    >
      Batalkan Sampah
    </vs-button>

    <!-- Disposition -->
    <DialogDisposisi
      ref="dialogDisposisi"
      :surat="surat"
      @submitCallback="submitCallback"
    />

    <!-- Nomor Surat -->
    <DialogNomorSurat
      ref="dialogNomorSurat"
      :suratUuid="surat.uuid"
      :suratId="surat.id"
      :kodeSurat="surat.kode_surat"
      @submitCallback="submitCallback"
    />
  </div>
</template>

<script>
import { UPDATE } from "../../../query/surat";
import { FIND } from "../../../query/pengguna";
import DialogDisposisi from "@/components/global/surat/DialogDisposisi";
import DialogNomorSurat from "@/components/global/surat/DialogNomorSurat";

export default {
  components: {
    DialogDisposisi,
    DialogNomorSurat,
  },
  props: {
    surat: {
      type: Object,
      required: true
    }
  },
  methods: {
    confirmArchive() {
      this.$root.confirmDialog({
        title: "Arsipkan surat ini ?",
        message: "Surat ini akan disimpan sebagai arsip",
        acceptTitle: "Arsipkan",
        cancelTitle: "Batal",
        onAccept: this.handleOnArchive
      });
    },

    async handleOnArchive() {
      try {
        await this.archiveSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Arsip surat sukses"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Arsip surat gagal"
        });
      }
    },

    async archiveSubmit() {
      // const archiveManager = await this.getArchiveManager();
      const variables = {
        id: this.surat.id,
        input: {
          status: "arsip",
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "archived",
                keterangan: "Surat diarsipkan",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },

    confirmSendMail() {
      this.$root.confirmDialog({
        title: "Kirim Surat",
        message: "Status surat menjadi terkirim dan surat akan diarsipkan",
        acceptTitle: "Iya, Kirim",
        cancelTitle: "Batal",
        onAccept: this.handleOnSendMail
      });
    },

    async handleOnSendMail() {
      try {
        await this.sendMailSubmit();
        this.$vs.notify({
          color: "success",
          title: "Berhasil",
          text: "Berhasil Mengirim Surat"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Gagal mengirim surat"
        });
      }
    },

    async sendMailSubmit() {
      const variables = {
        id: this.surat.id,
        input: {
          status: "terkirim",
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "send",
                keterangan: "Surat telah dikirim",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },

    confirmUnarchive() {
      this.$root.confirmDialog({
        title: "Batalkan Pengarsipan",
        message:
          "Batal Pengarsipan akan membuat surat ini dapat disposisikan kembali ?",
        acceptTitle: "Iya, batalkan",
        cancelTitle: "Kembali",
        onAccept: this.handleOnUnarchive
      });
    },

    async handleOnUnarchive() {
      try {
        await this.unarchiveSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Batalkan pengarsipan surat sukses"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Batalkan pengarsipan  surat gagal"
        });
      }
    },

    async unarchiveSubmit() {
      const variables = {
        id: this.surat.id,
        input: {
          status: "draft",
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "unarchived",
                keterangan: "Batal diarsipkan",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },

    handleAgenda() {
      this.$router.openNewTab({
        name: "agenda-buat",
        query: { surat: this.surat.uuid }
      });
    },

    // Trash Action
    confirmTrash() {
      this.$root.confirmDialog({
        title: "Jadikan surat ini sebagai sampah ?",
        message: "Surat ini akan batal digunakan dan menjadi sampah",
        acceptTitle: "Jadikan Sampah",
        cancelTitle: "Batal",
        onAccept: this.handleOnTrash
      });
    },

    async handleOnTrash() {
      try {
        await this.trashSubmit();
        this.$vs.notify({
          color: "success",
          title: "Berhasil",
          text: "Surat berhasil dijadikan sampah !"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Terjadi kesalahan, surat gagal dijadikan sampah !"
        });
      }
    },

    async trashSubmit() {
      const variables = {
        id: this.surat.id,
        input: {
          status: "sampah",
          disposisi_terakhir_pengguna_id: this.$user.id,
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "trashed",
                keterangan: "Surat dijadikan sampah",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },

    confirmUnTrash() {
      this.$root.confirmDialog({
        title: "Kembalikan surat ini menjadi draf ?",
        message: "Surat ini akan batal menjadi sampah dan kembali menjadi draft",
        acceptTitle: "Batalkan Menjadi Sampah",
        cancelTitle: "Kembali",
        onAccept: this.handleOnUnTrash
      });
    },

    async handleOnUnTrash() {
      try {
        await this.untrashSubmit();
        this.$vs.notify({
          color: "success",
          title: "Berhasil",
          text: "Surat berhasil dibatalkan menjadi sampah"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Terjadi kesalahan, surat gagal dibatalkan menjadi sampah!"
        });
      }
    },

    async untrashSubmit() {
      const variables = {
        id: this.surat.id,
        input: {
          status: "draft",
          disposisi_terakhir_pengguna_id: this.$user.id,
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "up",
                keterangan: "Surat dibatalkan menjadi sampah",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.submitCallback();
        }
      });
    },

    submitCallback(){
      this.$emit('refreshSurat');
    },

    async getArchiveManager() {
      const response = await this.$apollo.query({
        query: FIND,
        where: { column: "ROLE", value: "pengelola_arsip" }
      });
      const data = await response.data;
      return data.pengguna;
    },
  }
};
</script>
